export default {
    comment_box: {
        el: "#comment-box",
        loaded: false,
    },
};
